import { getUrl, request } from "../../../backend";
import { Agreement, CreateAgreementParams } from "../../../models/Agreement";
import Bundle from "../../../models/Bundle";
import CreditCheckResult from "../../../models/CreditCheckResult";
import Product from "../../../models/Product";

export async function fetchAgreementPreview(params: CreateAgreementParams, contentType: 'image' | 'pdf'): Promise<Blob> {
  const formData = new FormData();
  formData.append('json', JSON.stringify({
    ...params,
    contentType,
    upload: false,
    photo: null
  }));

  if (params.photo) {
    //  Genom att skicka med fotot så ser man den direkt i PDF:en
    formData.append('photo', params.photo);
  }

  return await request(`/agreement-preview`, 'post', formData);
}

/**
 * Creates and signs an agreement.
 */
export async function signNewAgreement(subscriptions: Product[], bundles: Bundle[], signee: CreditCheckResult, { offerSignatureUri, signatureMethod, monthlyPaymentTotal }, photo?: Blob):
  Promise<Agreement> {
  const formData = new FormData();
  formData.append('json', JSON.stringify({
    signee,
    bundles,
    subscriptions,
    offerSignatureUri,
    signatureMethod,
    monthlyPaymentTotal
  }));

  if (photo) {
    formData.append('photo', photo);
  }

  const { key, uri } = await request(`/signed-agreement`, 'post', formData);

  return new Agreement({ key, uri });
}

export async function declineAgreement(agreementKey: string) {
  await request(`/agreement/${agreementKey}/decline`, 'post');
}

/**
 * Signs an agreement which has been created and uploaded but is yet unsigned.
 */
export async function signExistingAgreement(agreementKey: string, args: { city?: string; signatureUri: string; acceptNotificationViaSms: boolean; }) {
  await request(`/signed-agreement/${agreementKey}`, 'post', {
    city: args.city,
    signee: { signatureUri: args.signatureUri },
    acceptNotificationViaSms: args.acceptNotificationViaSms
  });
}

/**
 * Signs an agreement which has been created and uploaded but is yet unsigned.
 */
export async function signExistingAgreementAsync(agreementKey: string, signatureUri: string) {
  const opts = new Blob([JSON.stringify({
    signee: { signatureUri }
  })], { type: 'application/json' });

  navigator.sendBeacon(getUrl(`/signed-agreement/${agreementKey}`), opts);
}